angular.module('rjmNg.directives').directive "resizerObserver", [
  "$window"
  "$timeout"
  "$parse"
  ($window, $timeout, $parse) ->
    restrict: "A"
    priority: 200
    controller: [
      "$scope"
      "$element"
      ($scope, $element) ->
        prevWidth = null
        prevHeight = null
        @resizeChildren = (width, height) ->
          if(prevWidth is width and prevHeight is height)
            return
          prevWidth = width
          prevHeight = height
          $scope.$broadcast "resizer-resize", width, height

        @
    ]
    link: (scope, elem, attrs, controller) ->

      promise = null
      windowResizeHandler = (event) ->
        if event.target isnt $window
          return
        if promise? then $timeout.cancel promise
        promise = $timeout ->
          controller.resizeChildren(elem.width(), elem.height())
          promise = null
        , 250
        , false

      if attrs.windowResize
        $($window).on 'resize', windowResizeHandler

      # {
      #    eventName : {
      #      width: string | function ([args...])
      #      height: string | function ([args...]) 
      #    }
      # }
      eventHandlerCreator = (eventArgs) ->
        promise = null
        return () ->
          args = Array.prototype.slice.call(arguments, 1); # cast arguments to an array and remove event object

          # handle string width argument
          if angular.isString(eventArgs.width)
            # handle using the current element's width
            if eventArgs.width is "this" or eventArgs.width = "@"
              width = elem.width()
            # handle an argument passed by the event handler
            else if eventArgs.width = "arg" or
              eventArgs.width = "arguments" and
              args.length is 1
                width = args[0]

          # handle string height argument
          if angular.isString(eventArgs.height)
            # handle using the current element's height
            if eventArgs.height is "this" or eventArgs.height = "@"
              height = elem.height()
            # handle an argument passed by the event handler
            else if eventArgs.height = "arg" or
              eventArgs.height = "arguments" and
              args.length is 2
                height = args[1]

          # check and use function argument
          if angular.isFunction(eventArgs.width)
            width = eventArgs.width(args)
          if angular.isFunction(eventArgs.height)
            height = eventArgs.height(args)

          controller.resizeChildren(width, height)

      # watch dom events object and register dom listeners
      domEventWatch = scope.$watch attrs.domEvents, (domEvents, old) ->
        unless domEvents
          return

        for eventName, eventArgs of domEvents
          elem.off eventName
          elem.on eventName, eventHandlerCreator(eventArgs)

      # watch scope events object and register scop listeners
      scopeListeners = []
      scopeEventWatch = scope.$watch attrs.scopeEvents, (scopeEvents, old) ->
        unless scopeEvents
          return
        # check to see if we need to cancel any existing scope listeners
        if scopeListeners.length > 0
          for listener in scopeListeners
            listener()

        scopeListeners = for eventName, eventArgs of scopeEvents
          scope.$on eventName, eventHandlerCreator(eventArgs)


      #resize all elements that have been registered on link so things have the correct initial size
      controller.resizeChildren(elem.width(), elem.height())

      scope.$on "$destroy", ->
        domEventWatch()
        scopeEventWatch()

        if attrs.windowResize
          $($window).off('resize', windowResizeHandler)

        if scope[attrs.domEvents]?
          for eventName, eventArgs of domEvents
            elem.off eventName

        for listener in scopeListeners
          listener()

  ]
